export const DEFAULT_PAGE_SIZE = 10;

export const MAX_MAJOR_MINOR = 65535;

export const beaconsPaginationParams = {
  page: 0,
  size: DEFAULT_PAGE_SIZE,
  // sort: 'id',
};
